<script lang="ts">
import { defineComponent } from 'vue';
import Competitor from '@/components/event/competitor.vue';
import Headline from '@/components/headline.vue';

export default defineComponent({
  name: 'description',
  components: { Headline, Competitor },
  props: ['fixture'],
});
</script>

<template>
  <headline class="mx-4 my-2"> Участники </headline>
  <template v-if="fixture.Competitors">
    <div
      v-for="competitor in fixture.Competitors"
      class="mx-3 my-2 bg-gray-200 dark:bg-gray-800 rounded-lg"
    >
      <competitor :competitor="competitor" :root="true" />
    </div>
  </template>
</template>

<style scoped lang="scss"></style>
